"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var react_1 = require("react");
var styles = {
    display: 'flex',
    padding: '10px 20px',
    flex: 1,
};
var ModalBody = (function (_super) {
    __extends(ModalBody, _super);
    function ModalBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalBody.prototype.render = function () {
        var _a = this.props, children = _a.children, style = _a.style;
        return (React.createElement("div", { style: [styles, style] }, children));
    };
    ModalBody = __decorate([
        Radium
    ], ModalBody);
    return ModalBody;
}(react_1.PureComponent));
exports.ModalBody = ModalBody;



//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/ModalBody.tsx
// module id = 317
// module chunks = 0